import React from 'react';
import PropTypes from 'prop-types';
import { Route, Routes } from 'react-router-dom';
import RenderRoute from './RenderRoute';

const ChildRoutes = ({ configs, isAdmin, isUser, locale, routes, tenantId, userAllowedTenants }) => {
  if (!routes) {
    return <>no routes found</>;
  }

  return (
    <Routes>
      {
        routes.map((route, i) => (
          <Route
            key={route.key || i}
            // react-router v6+ removed `exact` (paths match exactly by default) and
            // `strict`. The legacy fallback route with no path becomes path="*".
            path={route.path ?? '*'}
            element={(
              <RenderRoute
                configs={configs}
                isAdmin={isAdmin}
                isUser={isUser}
                locale={locale}
                route={route}
                tenantId={tenantId}
                userAllowedTenants={userAllowedTenants}
              />
            )}
          />
        ))
      }
    </Routes>
  );
};

ChildRoutes.propTypes = {
  configs: PropTypes.object,
  isAdmin: PropTypes.bool,
  isUser: PropTypes.bool,
  locale: PropTypes.string,
  routes: PropTypes.array.isRequired,
  tenantId: PropTypes.string,
  userAllowedTenants: PropTypes.arrayOf(PropTypes.number),
};

ChildRoutes.defaultProps = {
  configs: {},
  isAdmin: false,
  isUser: false,
  locale: 'en',
  userAllowedTenants: [],
};

export default ChildRoutes;
